import { animateScroll } from 'react-scroll';

const scrollWrapperId = '#scroll-wrapper';

export function scrollToTop(options = { duration: 0 }) {
  animateScroll.scrollToTop({
    containerId: scrollWrapperId,
    ...options,
  });
}

export function scrollTo(id, options) {
  const el = document.getElementById(id);
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'center', ...options });
  }
}
